import actions from './actions-product.js'
import mutations from './mutations-product.js'
import getters from './getters-product.js'
import state from './state-product.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}